export function initCountdownTimers(selector = '[data-countdown-timer]') {
	const timers = document.querySelectorAll(selector);
	let count = 0;
	timers.forEach((timer) => {
		count++;
		initCountdownTimer(timer, count);
	});
}

function initCountdownTimer(timer, count = 1) {
	if(!timer) return;
	const countdownTime = timer.dataset.countdownTime;
	if(!countdownTime) return;

	updateCountdownTimer(timer);
	timer.classList.add('init');

	window['CountdownTimer'+count] = setInterval(()=>{
		updateCountdownTimer(timer, count);
	}, 1000);


}

function updateCountdownTimer(timer, count = 1) {
	const countdownTime = parseInt(timer.dataset.countdownTime, 10) - 1;
	timer.dataset.countdownTime = countdownTime;
	let time = formatSeconds(countdownTime);

	if(countdownTime <= 0) {
		time = {	days: 0, hours: 0, minutes: 0, seconds: 0 };
		timer.classList.remove('init');
		timer.dataset.countdownTime = 0;
		clearInterval(window['CountdownTimer'+count]);
	}

	timer.querySelector('.days').innerText = time.days.toString().padStart(2, '0');
	timer.querySelector('.hours').innerText = time.hours.toString().padStart(2, '0');
	timer.querySelector('.minutes').innerText = time.minutes.toString().padStart(2, '0');
	timer.querySelector('.seconds').innerText = time.seconds.toString().padStart(2, '0');
}

function formatSeconds(totalSeconds) {
	const secondsInt = parseInt(totalSeconds, 10);

	// Calculate time units
	const days = Math.floor(secondsInt / (24 * 3600));
	const hours = Math.floor((secondsInt % (24 * 3600)) / 3600);
	const minutes = Math.floor((secondsInt % 3600) / 60);
	const seconds = secondsInt % 60;

	return {
		days: days,
		hours: hours,
		minutes: minutes,
		seconds: seconds
	};
}